<po-page-default p-title="Minhas Análises">
  
  <div class="po-row">
  
    <po-button
      class="po-md-2"
      (p-click)="createAnalysis.open()"
      p-kind="primary"
      p-icon="po-icon-database"
      p-label="Criar Análise" >
    </po-button>

    <po-button
      class="po-md-2"
      (p-click)="updateScreenData()"
      p-label="Atualizar" 
      p-icon="po-icon-refresh">
    </po-button>

  </div>

  <br>
  
  <div class="po-row" style="flex-direction: column;">
    <p class="infoLabel">* As queries desta lista estão resumidas. Para ver os resultados e a query completa, clique em <strong>"Detalhes"</strong>.</p>
  </div>  

  <br>

  <div class="po-row">
      <!-- <div class="po-md-12">
        <test-query></test-query>
      </div> -->

      <po-list-view
        class="po-md-12"
        p-hide-select-all
        [p-actions]="itemListOptions"
        [p-items]="analyses"
        p-property-title="shortQuery">
  
        <ng-template p-list-view-content-template let-item >
          <div class="po-row">
            <po-info p-label="ID" class="po-md-3" [p-value]="item.id"></po-info>
            <po-info p-label="Data" class="po-md-2" [p-value]="item.created_at" ></po-info>
          </div>
        </ng-template>
      </po-list-view>

    </div>

    <notificationComponentHM></notificationComponentHM>

    <div class="sample-container" *ngIf="loading">
      <po-loading-overlay></po-loading-overlay>
    </div>
</po-page-default>

<po-modal #createAnalysis
  p-title="Criar Análise"
  p-width="800px"
  p-height="600px"
  p-close="false"
  p-modal-type="normal"
  [p-primary-action]="analysisModalCreate"
  [p-secondary-action]="analysisModalCreateCancel"
  >

  <div class="po-row" style="flex-direction: column;">
    <p class="infoLabel" style="font-weight: bold;">ATENÇÃO!</p>
    <p class="infoLabel">Todas as análises ficam disponíveis por 3 dias em nosso banco de dados. Após esse período, as análises são deletadas automaticamente.</p>
  </div> 

  <br>
  
  <po-code-editor 
    [(ngModel)]=testQuery 
    p-height="250" 
    p-language="sql" 
    p-readonly="false" 
    p-show-diff="false" 
    p-theme="vs-dark"
  ></po-code-editor>

</po-modal>

<po-modal #deleteAnalysis
    p-title="Excluir Análise"
    [p-primary-action]="okDelete"
    [p-secondary-action]="cancelDelete">

    <div class="po-row">

      <po-select
        class="po-lg-6"
        name="delete"
        p-label="Deseja excluir a análise?"
        [p-required]="true"
        [(ngModel)]="canDelete"
        [p-options]="[{label: 'Não', value: 'NO'}, {label: 'Sim', value: 'YES'}]">
      </po-select>

    </div>

</po-modal>